module.exports = Intl;


//////////////////
// WEBPACK FOOTER
// external "Intl"
// module id = 34
// module chunks = 0